import ministryService from "../../../../services";
export default {
  namespaced: true,
  state: () => {
    return {
      working: false,
      loading: false,
      campaigns: [],
    };
  },
  getters: {
    working(state) {
      return state.working;
    },
    loading(state) {
      return state.loading;
    },
    campaigns(state) {
      return state.campaigns;
    },
  },
  mutations: {
    setWorking(state, payload) {
      state.working = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setData(state, payload) {
      state.campaigns = payload;
    },
  },
  actions: {
    async getCampaigns({ commit }) {
      commit("setLoading", true);
      try {
        const data = await ministryService.getCampaigns();
        commit("setData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },

    async approveCampaign({ commit }, payload) {
      commit("setWorking", true);
      try {
        await ministryService.approveCampaign(payload.id, payload.status);
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },

    async featureCampaign({ commit }, payload) {
      commit("setWorking", true);
      try {
        await ministryService.featureCampaign(payload.id, payload.value);
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
  },
};
